import React from 'react';
import Banner from '../../b2b-common/Banner';
import MUnitsCategoriesTable from '../components/MUnitsCategoriesTable';
import { ButtonGroup, IconButton, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import CategoryModal from '../modal/CategoryModal';

import './ListMUnitsCategories.css';

const ListMUnitsCategories = () => {

    const [openNewCategoryDialog, setOpenNewCategoryDialog] = React.useState(false);
    const [refreshTable, setRefreshTable] = React.useState(false);
    const [selectedCategory, setSelectedCategory] = React.useState(null);

    const handleSelectCategory = (selectedCategory) => {
        console.log('Category selected. ', selectedCategory);
        setSelectedCategory(selectedCategory);
        setOpenNewCategoryDialog(true);
    }

    return (
        <div className='list-measurement-units-categories-container'>
            <Banner message="Indicators Menu: List measurement units categories." />
            <MUnitsCategoriesTable
                onSelectedCategory={handleSelectCategory}
                refresh={refreshTable}
            />
        </div>
    );
};

export default ListMUnitsCategories;